












import { Vue, Component, Prop } from "vue-property-decorator";
import DocReviewDialog from "../Dialogs/DocReviewDialog.vue";
import { bus } from "../../main";
import * as data from "../../_store/data.module"

@Component({
    components:{
        DocReviewDialog
    }
})
export default class StatusDoc extends Vue{
@Prop() idDoc!:number;
@Prop() tipoDoc!: string;
// @Prop() activityType!: string;
@Prop() firmaAz!: string;
@Prop() firmaTir!: string;
@Prop() statoDoc!: number;

private convenzione: any;
  private progettoOrientamento: any;
  private attestatoFinale: any;
  private questionario: any;
  private show: boolean;
  private docType: string;

constructor(){
    super()
    this.convenzione = {};
    this.progettoOrientamento = {};
    this.attestatoFinale = {};
    this.questionario = {};
    this.show = false;
    this.docType = "";
}

openConvenzione() {
    // this.loadingConvenzioneReview = true;
    this.docType = "convenzione";
    bus.$emit("openDocConvenzioneReview", this.convenzione);
  }

  openProgettoOrientamento() {
    // this.loadingProgettoOrientamentoReview = true;
    this.docType = "progettoOrientamento";
    bus.$emit("openDocProgettoOrientamentoReview", this.progettoOrientamento);
  }

  openAttestatoFinale() {
    // this.loadingAttestatoFinaleReview = true;
    this.docType = "attestatoFinale";
    bus.$emit("openDocAttestatoFinaleReview", this.attestatoFinale);
  }

  openQuestionario() {
    // this.loadingQuestionarioReview = true;
    this.docType = "questionarioTirocinante";
    bus.$emit("openDocQuestionarioReview", this.questionario);
  }

  loadConvenzione() {
    var payload = {
      idDoc: this.idDoc,
    //   activityType: this.activityType
    };
    data
      .dispatchConvenzioneAttivitaFromId(this["$store"], payload)
      .then(result => {
        this.convenzione = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

//   loadProgettoOrientamento() {
//     var payload = {
//       idRichiesta: this.idRichiesta,
//       activityType: this.activityType
//     };
//     data
//       .dispatchProgettoOrientamento(this["$store"], payload)
//       .then(resp => {
//         this.progettoOrientamento = resp;
//       })
//       .catch(error => {
//         if (error.response.status === 403) {
//           bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
//           this["$router"].push("/login");
//         } else {
//           bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
//         }
//       });
//   }

//   loadAttestatoFinale() {
//     var payload = {
//       idRichiesta: this.idRichiesta,
//       activityType: this.activityType
//     };
//     data
//       .dispatchAttestatoFinaleInfo(this["$store"], payload)
//       .then(resp => {
//         this.attestatoFinale = resp;
//       })
//       .catch(error => {
//         if (error.response.status === 403) {
//           bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
//           this["$router"].push("/login");
//         } else {
//           bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
//         }
//       });
//   }

//   loadQuestionario() {
//     var payload = {
//       idRichiesta: this.idRichiesta,
//       activityType: this.activityType,
//       tipoQuestionario: this.tipoQuestionario
//     };
//     data
//       .dispatchRisposteQuestionario(this["$store"], payload)
//       .then(result => {
//         this.questionario = result;
//       })
//       .catch(error => {
//         if (error.response.status === 403) {
//           bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
//           this["$router"].push("/login");
//         } else {
//           bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
//         }
//       });
//   }
created(){
    if(this.tipoDoc === 'convenzione'){
        this.loadConvenzione()
    }
}

}
